/* eslint-disable import/prefer-default-export */
import { isBrowser, isMobile } from 'react-device-detect';
import React from 'react';
import PropTypes from 'prop-types';

export const VerificationActionButton = ({ disabled, onClick, label }) => (
  <button
    style={{ minWidth: `${!isMobile ? '8.75rem' : '7.5rem'}` }}
    className={`btn rounded-5 ${isBrowser ? 'py-1 px-4' : 'py-3 mt-3'} ${
      !disabled ? 'bg-primary text-white' : 'bg-disabled text-shadow'
    }`}
    disabled={disabled}
    type="button"
    tabIndex={0}
    onClick={onClick}
    onKeyDown={() => {}}>
    {label}
  </button>
);

VerificationActionButton.propTypes = {
  disabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string,
};

VerificationActionButton.defaultProps = {
  label: '',
};

export const UpgradeLevelButton = ({ onClick, label, disabled }) => (
  <button
    className="btn rounded-max btn-primary py-2 px-3 text-f6 d-sm-block d-none"
    type="button"
    disabled={disabled}
    onClick={onClick}>
    {label}
  </button>
);

UpgradeLevelButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string,
  disabled: PropTypes.bool,
};

UpgradeLevelButton.defaultProps = {
  label: '',
  disabled: false,
};
